 import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import deleteimg from '../../assets/images/icon/delete.png';


const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

function onChange_(date, dateString) {
  console.log(date, dateString);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			school_list: [],
			visible: false,
			value: '',
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('franchisorData')){
			var storedArray = JSON.parse(localStorage.getItem("franchisorData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let school_id = this.props.match.params.id;
			var app = {user_id : user_id,school_id:school_id}
			getData('franchise/school_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_school: result['total_school'],
						});
						
						
					}else{
						this.setState({
							school_list: [],
							total_school: 0,
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  handleCancel = () => this.setState({ previewVisible: false });

    showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  

  handleChange = ({ fileList }) => this.setState({ fileList });

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <img src={person} class="profile-img" />
        
      </div>
    );	
					
		return (
		
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6">
                       <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">View School</span></h5>
						
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/my-school/index">My School</a>
                           </li>
                           <li class="breadcrumb-item active">View School
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
			
			<div class="col s12 m12 ex-padd">
            {this.state.school_list.map((list) => (
            <div class="container view-Profile child-profile">
			   <div class="col s12 m12 mb-20 card-content iq-card  mobile-no-padd">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="School" classname="as" key="1">
						
						    <div class="col m12 s12">
								<div class="col m8 s12 mb-10">
									<label>School Name</label>
									<input type="text" value={list.name}  disabled/>
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Type</label>
									<input type="text" value={list.type}  disabled/>
								</div>	
							</div>	
							<div class="col m12 s12">
								<div class="col m4 s12 mb-10">
									<label>Country</label>
									<input type="text" value={list.country}  disabled/>
								</div>
								<div class="col m4 s12 mb-10">
									<label>City</label>
										<input type="text" value={list.city}  disabled/>
								</div>
								<div class="col m4 s12 mb-10">
									<label>Locality</label>
										<input type="text" value={list.locality}  disabled/>
								</div>								
							</div>	
						 
						
							
						<div class="col m12 s12">
							<div class="col m12 s12 mb-10">
								<label>Address</label>
								<input type="text" value={list.address}  disabled/>
							</div>							
													
						<div class="col m4 s12 mb-10">
								<label>Zipcode</label>
								<input type="text" value={list.zipcode}  disabled/>
						</div>
						<div class="col m4 s12 mb-10">
								<label>Currency</label>
								<input type="text" value={list.currency}  disabled/>
						</div>
						<div class="col m4 s12 mb-10">
								<label>Time Zone</label>
								<input type="text" value={list.timezone}  disabled/>			
						</div>
						</div>
									
						</Panel>
					  </Collapse>
					</div> 
					
					<div class="children bg-blue communication bb pb-20 mb-20  iq-card2 bg-color-6">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Admin Details"  key="1">
							
							{list.admin_details.map(admin =>
							<div class="col m6 s12 mb-10">
									<div class="shadow">
									<div class="col m12 s12 no-padd">
										<div class="col m12 s12 t-left mt-10 ">
											<label>First Name </label> : <span>{admin.admin_name}</span>
										</div>
										<div class="col m12 s12 t-left mt-10 no-padd">
											<div class="col m6 s12"><label>Phone Number </label> : <span>{admin.admin_number}</span></div>
											<div class="col m6 s12"><label>Email </label> : <span>{admin.admin_email}</span></div>
										</div>
									</div>
									
									</div>
							</div>
							)}
								
						</Panel>
					  </Collapse>
					</div>

						
					<div class="notice-left">
							<Link to={`${process.env.PUBLIC_URL}/my-school/my-school-edit/${list.id}`}><img src={edit} /></Link>
					</div>
					
						
					
					
				
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
			
			))}
			
         </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
